import React from 'react';

import { useIntl } from 'react-intl';

import IconLock from 'components/icons/lock-badge';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { IPlaceOrderButtonProps } from './types';

export const PlaceOrderText: React.FC<Omit<IPlaceOrderButtonProps, 'isLoading'>> = ({
  confirmation,
}) => {
  const { formatMessage } = useIntl();
  const twoStepCheckout = useFlag(LaunchDarklyFlag.TWO_STEP_CHECKOUT);

  const placeOrder = twoStepCheckout ? 'placeSecureOrder' : 'placeOrder';

  return (
    <>
      {formatMessage(
        {
          id: confirmation ? placeOrder : 'continue',
        },
        {
          secureOrderIcon: <IconLock />,
        }
      )}
    </>
  );
};
